module.exports = __webpack_public_path__ + "static/img/r-1-1.c4cca10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-1/r-1-1.png
// module id = tE3x
// module chunks = 0